/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Access Administration API
 * OpenAPI spec version: 1.0.0
 */
import type {AssignUserRoleRequest, PermissionOverrideRequest, UserAccessDto} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getGetAccessAdministrationUserAccessUrl = (userId: string) => {
  return `/api/v1/access-administration/users/${userId}/access`;
};

/**
 * @summary Get user access
 */
export const getAccessAdministrationUserAccess = async (
  userId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<UserAccessDto> => {
  return customFetch<UserAccessDto>(getGetAccessAdministrationUserAccessUrl(userId), {
    ...options,
    method: "GET",
  });
};

export const getAssignAccessAdministrationUserRoleUrl = (userId: string) => {
  return `/api/v1/access-administration/users/${userId}/roles`;
};

/**
 * @summary Assign role to user
 */
export const assignAccessAdministrationUserRole = async (
  userId: string,
  assignUserRoleRequest: AssignUserRoleRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getAssignAccessAdministrationUserRoleUrl(userId), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(assignUserRoleRequest),
  });
};

export const getRemoveAccessAdministrationUserRoleUrl = (userId: string, roleId: string) => {
  return `/api/v1/access-administration/users/${userId}/roles/${roleId}`;
};

/**
 * @summary Remove role from user
 */
export const removeAccessAdministrationUserRole = async (
  userId: string,
  roleId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRemoveAccessAdministrationUserRoleUrl(userId, roleId), {
    ...options,
    method: "DELETE",
  });
};

export const getSetAccessAdministrationUserPermissionOverrideUrl = (
  userId: string,
  permissionKey: string,
) => {
  return `/api/v1/access-administration/users/${userId}/permission-overrides/${permissionKey}`;
};

/**
 * @summary Set direct user permission override
 */
export const setAccessAdministrationUserPermissionOverride = async (
  userId: string,
  permissionKey: string,
  permissionOverrideRequest: PermissionOverrideRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(
    getSetAccessAdministrationUserPermissionOverrideUrl(userId, permissionKey),
    {
      ...options,
      method: "PUT",
      headers: {"Content-Type": "application/json", ...options?.headers},
      body: JSON.stringify(permissionOverrideRequest),
    },
  );
};

export const getRemoveAccessAdministrationUserPermissionOverrideUrl = (
  userId: string,
  permissionKey: string,
) => {
  return `/api/v1/access-administration/users/${userId}/permission-overrides/${permissionKey}`;
};

/**
 * @summary Remove direct user permission override
 */
export const removeAccessAdministrationUserPermissionOverride = async (
  userId: string,
  permissionKey: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(
    getRemoveAccessAdministrationUserPermissionOverrideUrl(userId, permissionKey),
    {
      ...options,
      method: "DELETE",
    },
  );
};
